import React, { useEffect, useState } from "react";
import "./LocationForm.scss";
import { ErrorLogger } from '../../../../utils/Logger';
import {
  Checkbox,
  FormControlLabel,
  FormGroup,
  Grid,
  TextField,
} from "@mui/material";
import CreateInput, { CreateDisabledInput } from "../../../CommonComponents/GGInputComponents/CreateInput";
import GGDropdownInput from "../../../CommonComponents/GGInputComponents/GGDropdownInput";
import { getDataFromPincode } from '../../../../services/JsonAPIS/JsonAPIS'
// import { getDataFromPincode2 } from "../../../../../services/JsonAPIS/JsonAPIS";
import { SellerAPIHandler } from "../../../../services/NetworkClient/BackendAPIs/SellerAPIhandler";

const enum stateEnum {
  state,
  region,
  country,
  pincode,
}

const LocationForm = (props: any) => {
  const {
    sellerFormData,
    setSellerFormData,
    languageStyles,
    initialIsFirstReload = true,
  } = props;

  const [fetchedData, setFetchedData] = useState([]);
  const [pincode, setPincode] = useState(0);
  const [country, setCountry] = useState("");
  const [state, setState] = useState("");
  const [languages, setLanguages] = useState<string[]>([]);
  const [isFirstReload, setIsFirstReload] = useState(initialIsFirstReload);
  const [hasInitialDataLoaded, setHasInitialDataLoaded] = useState(false);
  const [otherLanguages, setOtherLanguages] = useState<string[]>([]);
  // Dropdown states
  const [region, setRegion] = useState("");

  // Dropdown list
  const [regionList, setRegionList] = useState<string[] | []>([]);
  const [isPincodeLoading, setIsPincodeLoading] = useState(false);

  const handleOnchangeInput = (newData: string, state: stateEnum) => {
    if (hasInitialDataLoaded) {
      setIsFirstReload(false);
    }
    switch (state) {
      case stateEnum.region:
        setRegion(newData);
        setSellerFormData({
          ...sellerFormData,
          location: { ...sellerFormData.location, region: newData },
        });
        break;
      case stateEnum.pincode:
        setPincode(parseInt(newData));
        setSellerFormData({
          ...sellerFormData,
          location: { ...sellerFormData.location, pincode: newData },
        });
        break;
      default:
        break;
    }
  };

  const handleOtherLanguagesChange = (
    e: React.ChangeEvent<HTMLInputElement>
  ) => {
    const languagesArray = e.target.value.split(",").map((lang) => lang.trim());
    setOtherLanguages(languagesArray);
  };

  const handleOnchangeCheckbox = (data: string) => {
    const languageList = languages.includes(data)
      ? [...languages.filter((item) => item !== data)]
      : [...languages, data];
    setLanguages([...languageList]);
    setSellerFormData({
      ...sellerFormData,
      location: { ...sellerFormData.location, languages: [...languageList] },
    });
  };

  useEffect(() => {
    SellerAPIHandler.shared
      .getSellerFormData()
      .then((response) => {
        const initLocationData =
          response.location && Object.keys(response.location).length > 0
            ? { ...response.location }
            : { ...sellerFormData.location };
        setPincode(initLocationData.pincode);
        setCountry(initLocationData.country);
        setState(initLocationData.state);
        setLanguages(initLocationData.languages);
        setRegion(initLocationData.region);
        setRegionList([initLocationData.region]);
        // set sellerFormData
        if (response) {
          setSellerFormData({
            ...sellerFormData,
            location: { ...initLocationData },
          });
        }
      })
      .catch((err) => { ErrorLogger.log(err, 'LocationForm'); });
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    const fetchLocData = async () => {
      setIsPincodeLoading(true);
      const result = await getDataFromPincode(pincode.toString())

      if(result && result[0].PostOffice) {
        const data = result?.[0].PostOffice
        const locData = data.map((item:any) => {
          return {
            region: `${item["Name"]}, ${item["District"]}`,
            pincode: pincode,
            state: item["State"],
            country: item["Country"]
          }
        })
        setFetchedData(locData)
      }

      //Below one is broken on 26/10/2025 using above one

      // {
      // const result2 = await getDataFromPincode2(pincode.toString());
      // if (result2 && result2["records"]) {
      //   const data = result2["records"];
      //   const locData = data.map((item: any) => {
      //     let reg = "";
      //     if (item["officename"]) {
      //       reg = item["officename"].includes("S.O")
      //         ? item["officename"].split("S.O")[0]
      //         : item["officename"].includes(" SO")
      //         ? item["officename"].split(" SO")[0]
      //         : item["officename"].includes(" BO")
      //         ? item["officename"].split(" BO")[0]
      //         : "";
      //     }
      //     return {
      //       region: `${reg}, ${item["district"]}`,
      //       pincode: pincode,
      //       state: item["statename"],
      //       country: "India",
      //     };
      //   });
      //   setFetchedData(locData);
      // }
      // }

      setIsPincodeLoading(false);

    };
    if (!isFirstReload) {
      pincode && pincode.toString().length === 6
        ? fetchLocData()
        : setFetchedData([]);
      if (!pincode || pincode.toString().length !== 6) {
        setIsPincodeLoading(false);
      }
    }
    // eslint-disable-next-line
  }, [pincode]);

  useEffect(() => {
    if (fetchedData && fetchedData.length > 0) {
      setRegionList(fetchedData?.map((item) => item["region"]));
    } else {
      setRegionList([]);
      setCountry("");
      setSellerFormData({
        ...sellerFormData,
        location: { ...sellerFormData.location, country: "" },
      });
      setState("");
      setSellerFormData({
        ...sellerFormData,
        location: { ...sellerFormData.location, state: "" },
      });
    }
    // eslint-disable-next-line
  }, [fetchedData]);

  useEffect(() => {
    if (regionList && regionList.length > 0 && region && region.length > 0) {
      fetchedData.forEach((item) => {
        if (item["region"] === region) {
          setCountry(item["country"]);
          setState(item["state"]);
          setSellerFormData({
            ...sellerFormData,
            location: {
              ...sellerFormData.location,
              country: item["country"],
              state: item["state"],
            },
          });
        }
      });
    }
    // eslint-disable-next-line
  }, [region]);

  useEffect(() => {
    if (sellerFormData.location) {
      // Check if this is meaningful data (not just empty object)
      const hasData =
        sellerFormData.location.pincode ||
        sellerFormData.location.region ||
        sellerFormData.location.country ||
        sellerFormData.location.state;

      if (hasData && !hasInitialDataLoaded) {
        // This is the initial data load - set state without triggering auto-populate
        setPincode(sellerFormData.location.pincode || "");
        setRegion(sellerFormData.location.region || "");
        setCountry(sellerFormData.location.country || "");
        setState(sellerFormData.location.state || "");
        setLanguages(sellerFormData.location.languages || []);
        setHasInitialDataLoaded(true);
      }
    }
  }, [sellerFormData, hasInitialDataLoaded]);

  const LocationComp = () => (
    <>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6} md={6}>
          <CreateInput
            error={false}
            errorMsg=""
            label="Pincode"
            type="pincode"
            stateName={stateEnum.pincode}
            setStateFunction={handleOnchangeInput}
            preValue={pincode && pincode !== 0 ? pincode.toString() : ""}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={6}>
          <GGDropdownInput
            label="Region"
            options={regionList}
            stateName={stateEnum.region}
            setStateFunction={handleOnchangeInput}
            preValue={region}
            loading={isPincodeLoading}
          />
        </Grid>
      </Grid>
      <br />
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6} md={6}>
          <CreateDisabledInput
            error={false}
            errorMsg=""
            label="Country"
            type=""
            defaultValue={country}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={6}>
          <CreateDisabledInput
            error={false}
            errorMsg=""
            label="State"
            type=""
            defaultValue={state}
          />
        </Grid>
      </Grid>
    </>
  );

  const LanguageComp = () => (
    <div className="locationForm_languageComp">
      <div
        className="locationForm_languageComp_head"
        style={languageStyles || {}}
      >
        Language:
      </div>
      <FormGroup style={languageStyles || {}}>
        <FormControlLabel
          control={
            <Checkbox
              checked={languages && languages.includes("English")}
              onChange={() => handleOnchangeCheckbox("English")}
            />
          }
          label="English"
        />
        <FormControlLabel
          control={
            <Checkbox
              checked={languages && languages.includes("Hindi")}
              onChange={() => handleOnchangeCheckbox("Hindi")}
            />
          }
          label="Hindi"
        />
        <FormControlLabel
          control={
            <Checkbox
              checked={languages && languages.includes("Other")}
              onChange={() => handleOnchangeCheckbox("Other")}
            />
          }
          label="Other"
        />
        {languages.includes("Other") && (
          <TextField
            label="Specify Other Languages (comma-separated)"
            variant="outlined"
            fullWidth
            value={otherLanguages.join(", ")}
            onChange={handleOtherLanguagesChange}
          />
        )}
      </FormGroup>
    </div>
  );

  return (
    <div className="locationForm">
      {LocationComp()}
      {LanguageComp()}
    </div>
  );
};

export default LocationForm;
